<template>
  <transition name="slide">
    <article :class="cardClasses">
      <slot></slot>
    </article>
  </transition>
</template>

<script>
export default {
  name: 'Card',
  props: {
    theme: {
      type: String,
      default: 'light',
      validator: function (value) {
        return ['light', 'brown', 'blue', 'pink'].indexOf(value) !== -1
      }
    }
  },
  computed: {
    cardClasses () {
      return [
        'card',
        `theme-${this.theme}`
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.slide-enter,
.slide-leave-to {
  opacity: 0;
  transform: translate(-20px, -40px) rotate(-4deg);
  transform-origin: 100% 100%;
}

.card {
  background-color: white;
  border-radius: 10px;
  height: 504px;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  color: $c-dark;
  text-align: center;
  padding: 42px 30px 35px;
  box-shadow: 0 3px 15px rgba($c-dark, 0.25);
  transition: transform 800ms cubic-bezier(0.19, 1, 0.22, 1), opacity 1000ms cubic-bezier(0.19, 1, 0.22, 1) 400ms;
  will-change: transform, opacity;
  transform-origin: 50% 100%;
  touch-action: manipulation;

  @media (max-width: 479px) {
    padding-top: 30px;
  }
}

.card /deep/ h3 {
  font-size: $fs-h3;
  font-weight: $fw-bold;
}

.theme-light {
  color: $c-dark;
  background-color: white;
}

.theme-brown {
  color: white;
  background-color: $c-brown;
}

.theme-blue {
  color: white;
  background-color: #1F7F8D;
}

.theme-pink {
  color: white;
  background-color: $c-pink;
}
</style>
